import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import LeftIcon from './ic-left.component.svg'
import RightIcon from './ic-right.component.svg'

class Paginator extends Component {
  constructor() {
    super()
    this.state = {
      currentPage: 1,
      limit: 10,
      offset: 0,
    }
  }

  componentWillMount() {
    this.setState({ currentPage: this.props.currentPage })
  }

  setPage(page) {
    this.setState(
      { currentPage: page, offset: (page - 1) * this.state.limit },
      () => {
        this.props.pageChange(this.state)
      }
    )
  }

  render() {
    const { count } = this.props
    const nextPage = () => {
      const next = this.state.currentPage + 1
      if (next <= this.maxPages) {
        this.setPage(next)
      }
    }

    const prevPage = () => {
      const prev = this.state.currentPage - 1
      if (prev > 0) {
        this.setPage(prev)
      }
    }
    this.maxPages = Math.ceil(count / this.state.limit)
    return (
      <Container>
        <Page onClick={() => prevPage()}>
          {' '}
          <LeftIcon />{' '}
        </Page>
        {this.state.currentPage - 2 > 1 && (
          <Page onClick={(e) => this.setPage(1)}>1</Page>
        )}
        {this.state.currentPage - 2 > 1 && <Page>...</Page>}
        {this.state.currentPage > 1 && (
          <Page onClick={(e) => this.setPage(this.state.currentPage - 1)}>
            {this.state.currentPage - 1}
          </Page>
        )}
        <Page
          className='current'
          onClick={(e) => this.setPage(this.state.currentPage)}>
          {this.state.currentPage}
        </Page>
        {this.state.currentPage + 1 <= this.maxPages && (
          <Page onClick={(e) => this.setPage(this.state.currentPage + 1)}>
            {this.state.currentPage + 1}
          </Page>
        )}
        {this.state.currentPage + 2 < this.maxPages && <Page>...</Page>}
        {this.state.currentPage + 2 < this.maxPages && (
          <Page onClick={(e) => this.setPage(this.maxPages)}>
            {this.maxPages}
          </Page>
        )}
        <Page onClick={() => nextPage()}>
          {' '}
          <RightIcon />{' '}
        </Page>
      </Container>
    )
  }
}

Paginator.propTypes = {
  pageChange: PropTypes.func,
  count: PropTypes.number,
}

const Container = styled.div`
  border-radius: 2px 0 0 2px;
  height: 55px;
  display: inline-block;
  margin: 0 auto;
  display: inline-flex;
  justify-content: center;

  @media (max-width: 860px) {
    height: 48px;
    width: 100%;
  }
`

const Page = styled.div`
  width: 55px;
  height: 100%;
  text-align: center;

  cursor: pointer;

  color: #9c9c9c;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  &.current {
    color: #006736;
  }

  @media (max-width: 860px) {
    width: 48px;
    line-height: 48px;
  }
`

export default Paginator



// WEBPACK FOOTER //
// ./src/components/PaginationV2/index.js